import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DMConfigErrorType } from '#src/types/DMConfigErrorType'

export default class DMConfigError extends BaseError<DMConfigErrorType> {
  constructor(
    public message: string,
    public code: DMConfigErrorType,
    public options?: {
      cause?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DMConfigError.prototype)
    this.name = this.constructor.name
  }
}
